import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[only-email]'
})
export class EmailDirective {

  constructor(private element:ElementRef) { }

  @HostListener('input') onInput(event:KeyboardEvent) {
    const text = this.element.nativeElement.value;
    this.element.nativeElement.value = text.replace(/[^0-9a-zA-Z\-\.\@\_\s]/g, '');
  }

}
